import { Link, useLocation } from 'react-router-dom';
import T from '@wojtekmaj/react-t';

import LoginEmailForm from './form';

export default function LoginEmail() {
  const location = useLocation();

  return (
    <>
      <LoginEmailForm />
      <p>
        <T>Don’t have an account yet?</T>{' '}
        <Link to="/register_with_details" state={location.state}>
          <T>Register</T>
        </Link>
        .
      </p>
    </>
  );
}
